import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue";
var _hoisted_1 = {
  "class": "login"
};
var _hoisted_2 = {
  "class": "flex2 login2"
};
var _hoisted_3 = {
  "class": "login2_top"
};
var _hoisted_4 = {
  "class": "login2a"
};
var _hoisted_5 = {
  "class": "title"
};
var _hoisted_6 = {
  "class": "flex1 flex flexw flexc"
};
var _hoisted_7 = {
  key: 0,
  "class": "title_line"
};
var _hoisted_8 = {
  "class": "flex1 flex flexw flexc"
};
var _hoisted_9 = {
  key: 0,
  "class": "title_line"
};
var _hoisted_10 = {
  "class": "ww100 flex"
};
var _hoisted_11 = {
  "class": "password"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _this = this;
  var _component_el_input = _resolveComponent("el-input");
  var _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[19] || (_cache[19] = _createElementVNode("div", {
    "class": "flex1 login1"
  }, null, -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[9] || (_cache[9] = _createElementVNode("div", {
    "class": "flex1"
  }, null, -1)), _cache[10] || (_cache[10] = _createElementVNode("p", null, "还没有账号？", -1)), _createElementVNode("p", {
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.$router.push('/register');
    }),
    "class": "point",
    style: {
      "color": "#256EC3"
    }
  }, "立即注册 >")]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("p", {
    "class": _normalizeClass($data.type == 1 ? 'title_items' : 'title_item'),
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return $options.cgeTab(1);
    })
  }, "验证码登录", 2), $data.type == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_7)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("p", {
    "class": _normalizeClass($data.type == 2 ? 'title_items' : 'title_item'),
    onClick: _cache[2] || (_cache[2] = function ($event) {
      return $options.cgeTab(2);
    })
  }, "密码登录", 2), $data.type == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_9)) : _createCommentVNode("", true)])]), $data.type == 1 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createVNode(_component_el_input, {
    placeholder: "请输入手机号码",
    modelValue: $data.mobileOrEmail,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
      return $data.mobileOrEmail = $event;
    }),
    style: {
      "background-color": "#F5F7F9"
    },
    "class": "radius4"
  }, null, 8, ["modelValue"]), _cache[12] || (_cache[12] = _createElementVNode("p", {
    "class": "h30"
  }, null, -1)), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_input, {
    placeholder: "请慎入短信验证码",
    modelValue: $data.verificationCode,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
      return $data.verificationCode = $event;
    }),
    "class": "radius4"
  }, null, 8, ["modelValue"]), _createElementVNode("p", {
    onClick: _cache[5] || (_cache[5] = function () {
      return $options.sendVerificationCode && $options.sendVerificationCode.apply($options, arguments);
    }),
    "class": "yzm_button point"
  }, _toDisplayString($data.countdown > 0 ? "".concat($data.countdown, " \u79D2\u540E\u91CD\u8BD5") : '发送验证码'), 1)]), _cache[13] || (_cache[13] = _createElementVNode("p", {
    "class": "ww100 inbl tc mart40 col6 font12"
  }, "未注册平台产品的手机号，登录将自动注册", -1)), _cache[14] || (_cache[14] = _createElementVNode("div", {
    "class": "h20"
  }, null, -1)), _createVNode(_component_el_button, {
    loading: $data.loading,
    type: "primary",
    onClick: $options.tologins,
    "class": "ww100"
  }, {
    "default": _withCtx(function () {
      return _cache[11] || (_cache[11] = [_createTextVNode("立即登录")]);
    }),
    _: 1
  }, 8, ["loading", "onClick"])], 64)) : _createCommentVNode("", true), $data.type == 2 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createVNode(_component_el_input, {
    placeholder: "输入账号",
    modelValue: $data.mobileOrEmail,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
      return $data.mobileOrEmail = $event;
    }),
    "class": "radius4"
  }, null, 8, ["modelValue"]), _cache[17] || (_cache[17] = _createElementVNode("p", {
    "class": "h30"
  }, null, -1)), _createVNode(_component_el_input, {
    "auto-complete": "",
    modelValue: $data.password,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) {
      return $data.password = $event;
    }),
    placeholder: "请输入密码",
    "show-password": ""
  }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_11, [_cache[15] || (_cache[15] = _createElementVNode("div", {
    "class": "h20 flex1"
  }, null, -1)), _createElementVNode("p", {
    onClick: _cache[8] || (_cache[8] = function ($event) {
      return _this.$router.push('/password');
    }),
    "class": "point"
  }, "忘记密码?")]), _cache[18] || (_cache[18] = _createElementVNode("p", {
    "class": "h40"
  }, null, -1)), _createVNode(_component_el_button, {
    loading: $data.loading,
    type: "primary",
    onClick: $options.tologin,
    "class": "ww100"
  }, {
    "default": _withCtx(function () {
      return _cache[16] || (_cache[16] = [_createTextVNode("立即登录")]);
    }),
    _: 1
  }, 8, ["loading", "onClick"])], 64)) : _createCommentVNode("", true)])])]);
}